import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import RecentUpdatesNotificationCard from '../RecentUpdatesNotificationCard';

/**
 * @typedef {object} ChangeDateRequestReviewPageNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {ChangeDateRequestReviewPageNotificationProps} props
 */
const ChangeDateRequestReviewPageNotification = props => {
  const { notification } = props;

  const redirectUrl = pageUrlService.getChangeDateRequestReviewPageUrl(notification.RequestId);

  return (
    <RecentUpdatesNotificationCard
      name={notification.Name}
      label='Date Change has been submitted.'
      notificationDaysAgo={notification.NotificationDaysAgo}
      redirectUrl={redirectUrl}
    />
  );
};

export default ChangeDateRequestReviewPageNotification;
